export default import.meta.ROLLDOWN_FILE_URL_WPGYjwIlzWVNM1bYhOc83w_0ffd6482dcafbd9b2a33f873